import { CheckCircle2, Info, X, XCircle } from 'lucide-react'
import { createPortal } from 'react-dom'

import { cn } from '@/utils/cn'

import { useToastStore, type ToastTone } from './toast'

const ICONS: Record<ToastTone, typeof Info> = {
  success: CheckCircle2,
  error: XCircle,
  info: Info,
}

const ACCENT: Record<ToastTone, string> = {
  success: 'text-ok',
  error: 'text-critical',
  info: 'text-progress',
}

export function Toaster() {
  const toasts = useToastStore((state) => state.toasts)
  const dismiss = useToastStore((state) => state.dismiss)

  if (typeof document === 'undefined') return null

  return createPortal(
    <div
      className="pointer-events-none fixed inset-x-0 top-0 z-[60] flex flex-col items-center gap-2 p-3 pt-[calc(0.75rem+env(safe-area-inset-top))] sm:inset-x-auto sm:right-0 sm:items-end"
      role="region"
      aria-live="polite"
    >
      {toasts.map((toast) => {
        const Icon = ICONS[toast.tone]
        return (
          <div
            key={toast.id}
            className="pc-animate-toast pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-xl border border-line bg-surface p-3 shadow-lg"
          >
            <Icon className={cn('mt-0.5 size-5 shrink-0', ACCENT[toast.tone])} />
            <p className="flex-1 text-sm text-fg">{toast.message}</p>
            {toast.action && (
              <button
                type="button"
                onClick={() => {
                  toast.action?.onClick()
                  dismiss(toast.id)
                }}
                className="shrink-0 text-sm font-semibold text-brand hover:underline"
              >
                {toast.action.label}
              </button>
            )}
            <button
              type="button"
              onClick={() => dismiss(toast.id)}
              aria-label="Fechar aviso"
              className="text-fg-subtle hover:text-fg"
            >
              <X className="size-4" />
            </button>
          </div>
        )
      })}
    </div>,
    document.body,
  )
}
